// @ts-nocheck

import { KLStateActionTypes } from '../types/actions/kl';

export const updateKLUserState = ({ userStateMutation }) => ({
  type: KLStateActionTypes.UPDATE_KL_STATE,
  payload: {
    userStateMutation,
  },
});

export const skipAllKLTemporaryNotifications = () => ({ type: KLStateActionTypes.SKIP_ALL_KL_TMP_NOTIFICATIONS });

export const skipCurrentKLTemporaryNotification = () => ({ type: KLStateActionTypes.SKIP_CURRENT_KL_TMP_NOTIFICATION });

export const flushKLNotifications = () => ({ type: KLStateActionTypes.FLUSH_KL_NOTIFICATIONS });

export const restartKLAdventure = () => ({ type: KLStateActionTypes.RESTART_KL_ADVENTURE });

export const reviewKLAdventure = () => ({ type: KLStateActionTypes.REVIEW_KL_ADVENTURE });

export const fillTemporaryKLNotification = () => ({ type: KLStateActionTypes.FILL_TEMPORARY_KL_NOTIFICATIONS });

export const setKLOrientationPaginationIndex = (index) => ({
  type: KLStateActionTypes.SET_KL_ORIENTATION_PAGINATION_INDEX,
  payload: {
    index,
  },
});

export const setKLHomeVisitedIndex = (index) => ({
  type: KLStateActionTypes.SET_KL_HOME_VISITED_INDEX,
  payload: {
    index,
  },
});
